module.exports = __webpack_public_path__ + "static/media/playstore@2x.e4c5fd3b.png";